import { makeStyles, withStyles } from '@material-ui/core/styles';
import { colors } from '../../../constants/colors/Colors';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
export const useStyles = makeStyles((theme) => ({
    newAclEntryContainer: {
        width: 752,
        height: 451,
        paddingTop: 35,
        paddingBottom: 35,
        paddingRight: 40,
        paddingLeft: 40,
        borderRadius: 6,
        backgroundColor: '#E6EDF3',
        marginTop: 40,
        "@media (max-width: 1200px)": {
            width: '100%',
        },
    },
    addNewAclEntryTxt: {
        color: colors.titleColor,
        letterSpacing: '-0.0014em',
        fontSize: 20,
        fontWeight: '500',
        marginTop: 0,
    },
    inputLabel: {
        color: colors.titleColor,
        fontSize: 16,
        fontWeight: '400',
        marginTop: 15,
        marginBottom: 0,
    },
    inputField: {
        borderRadius: 8,
        boxSizing: 'border-box',
        border: '1px solid #D4DDE4',
        backgroundColor: '#F4F6F8',
        width: '100%',
        height: 49,
        padding: 14,
        marginTop: 10,
        "@media (max-width: 700px)": {
            width: '100%',
        },
    },
    addBtnContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
    },
    addBtn: {
        borderRadius: 6,
        background: 'linear-gradient(90deg, #824ED2 -0.14%, #B07DFF 99.93%)',
        width: 142,
        height: 42,
        color: '#FFFFFF',
        fontSize: 16,
        fontWeight: '400',
        border: 'none',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        marginTop: 20,
        "@media (max-width: 700px)": {
            width: '100%',
        },
    },
    inputWithIconContainer: {
        width: '100%',
        display: "inline-flex",
        alignItems: 'center',
        marginTop: 30,
    },
    searchInput: {
        height: 50,
        width: 752,
        backgroundColor: '#F4F6F8',
        borderRadius: 6,
        color: '#5B6773',
        border: '1px solid #D4DDE4',
        boxSizing: 'border-box',
        paddingLeft: 15,
        letterSpacing: '-0.1px',
        fontSize: 16,
        fontWeight: '400',
        fontStyle: 'normal',
        paddingRight: 60,
        "@media (max-width: 1200px)": {
            width: '100%',
        },
    },
    iconContainer: {
        backgroundColor: '#F4F6F8',
        width: 30,
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        right: 33.5,
        height: 42,
        "@media (max-width: 1200px)": {
            position: 'absolute',
            right: 60,
        },
    },
    eventContainer: {
        borderRadius: 12,
        marginTop: 30,
    },
    table: {
        minWidth: 950,
        [theme.breakpoints.down('sm')]: {
            width: 1500,
        },
    },
    permissionBtn:{
        width:97,
        height:38,
        borderRadius:6,
        border:'1px solid #D4DDE4',
        backgroundColor:'#F4F6F8',
        color:'#5B6773',
        fontSize:16,
        fontWeight:'600',
        cursor:'pointer',
    },
    removeIcon:{
        marginLeft:25,
        cursor:'pointer',
    },
}));

export const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#5B6773',
        color: '#ffffff',
        height: 52,
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: 16,
        paddingLeft: 30
    },
    body: {
        fontSize: 14,
        height: 52,
        color: '#5B6773',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: 16,
        paddingLeft: 30,
    },
}))(TableCell);

export const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(even)': {
            backgroundColor: '#F4F6F8',
        },
    },
}))(TableRow);